import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Util } from 'src/app/shared/helpers/util';

@Component({
  selector: 'app-hom2400',
  templateUrl: './hom2400.component.html',
  styleUrls: ['./hom2400.component.css']
})
export class HOM2400Component implements OnInit {
  viewText: any;
  langCode = this.translate.currentLang;
  isSession: any;
  util = new Util();
  constructor(
    private router: Router,
    private location: Location,
    private translate: TranslateService,
  ) {
    this.translate = translate;
  }

  ngOnInit() {
    this.langCode = this.util.getSecureStorage( "langCode" ) || "en";
    this.translate.use(this.langCode);
  }

  onGoHome() {
    this.router.navigate( [ '/main/home' ] );
  }

  onGoBack() {
    this.location.back();
  }

}
